import LabelStageNames from './LabelStageNames-compose';

export default LabelStageNames;
